export function checkHasDataChangedForRenewal(
  val: string | number,
  previousVal: string | number
) {
  const value = String(val).slice(0, 2);
  const previousValue = String(previousVal).slice(0, 2);

  return value !== previousValue;
}
